// Copyright 2021-2023 The MathWorks, Inc.

/* require([
    'docsurvey-ui/js/start',
    'dojo/domReady!'
], async (startPromise) => {
    const startModule = await startPromise;
    startModule.start();
}); */

define([
    'mw-ddux/UsageLogger',
    'mw-messageservice/MessageService',
    'mw-rating/Rating',
    'mw-rating-feedback/RatingFeedback',
    'mw-utils/Utils'
], function (UsageLogger, MessageService, Rating, RatingFeedback, Utils) {
    let feedbackId;
    let widget = document.querySelector('mw-rating-feedback');
    let pageURL = window.location.href;
    let docURL = pageURL;
    let docURLTemp = '';
    let docLang = '';
    let docLangNode = document.getElementById('doc_center_content');
    if (docLangNode) {
        docLang = document.getElementById('doc_center_content').dataset.language;
    }
    let pattern = '&surveyParams=';
    let g11nStr = '-G11N-';
    // If feedback is submitted through an iframe (18b-21b docs), the doc page's URL (encoded) and locale will
    // be captured.
    // If feedback is submitted through a Yes/No button (18a and earlier docs), only the doc page's URL will be captured.
    if (pageURL.indexOf(pattern) >= 0) {
        docURL = pageURL.substring(pageURL.indexOf(pattern) + pattern.length);
        if (docURL.indexOf(g11nStr) >= 0) {
            docURLTemp = docURL;
            docURL = docURL.substring(0, docURL.indexOf(g11nStr));
            docLang = docURLTemp.substring(docURLTemp.indexOf(g11nStr) + g11nStr.length);
        }
        docURL = decodeURIComponent(docURL);
    }
    widget.addEventListener('ratingstepchange', (evt) => {
        if (evt.detail.step === 0) {
            // Got rating but no comment yet.  Log the rating immediatly since the comment
            // is optional and therefore may never arrive.
            // Start UsageLogger lazily. If it was already started as part of application startup
            // this is unnecessary.  However, it won't do any harm since redundant starts are ignored.
            // Configure the UsageLogger to send data directly to the DDUX server unless the page was server up from localhost.
            // The DDUX server won't accept cross origin posts from other than mathworks.com.  Presumably, if the hostname
            // is localhost the page was served up by MATLAB which can send the data to the DDUX server.
            let sendDirect = ((window.location.hostname !== 'localhost') && (window.location.hostname !== '127.0.0.1'));
            if (!sendDirect) {
                MessageService.start();
            }
            UsageLogger.start({
                applicationName: 'DOC_FEEDBACK',
                applicationVersion: '1.0',
                sendDirect: sendDirect
            });
            // Generate a random id that can be used to tie the rating with a subsequent comment
            feedbackId = Utils.generateUuid();
        }
        UsageLogger.logData({
            rating: evt.detail.values.rating,
            comment: evt.detail.values.comment,
            feedbackId: feedbackId,
            context: docURL,
            context2: docLang
        }, {
            eventKey: 'CUSTOMER_FEEDBACK'
        });
    });
});
